import { render, staticRenderFns } from "./explain-header.component.vue?vue&type=template&id=000fccdc&scoped=true"
import script from "./explain-header.component.vue?vue&type=script&lang=ts"
export * from "./explain-header.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-header.component.vue?vue&type=style&index=0&id=000fccdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000fccdc",
  null
  
)

export default component.exports